<template>
  <div class="home-container">
    <div class="home-content">
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="weight" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="icon" label="图片" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.icon" min-width="70" height="70" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="status" label="是否启用" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>        
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="排序" prop="weight">
                 <el-input-number v-model="addData.weight" :min="1"  label="请输入排序"></el-input-number>
              </el-form-item>
            </el-col>
          </el-row> 
          <el-row>
            <el-col :span="24">
              <el-form-item label="banner" prop="icon">
                <upload
                  :url.sync="addData.icon"
                  :src="addData.icon"
                  type="img"
                  :width="52"
                  :height="52"
                ></upload>
                <div style="color: red">*(建议尺寸52px * 52px)）</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="名称" prop="name">
                <el-input
                  v-model="addData.name"
                  placeholder="请输入名称"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>   
          <el-row>
            <el-col :span="24">
              <el-form-item label="跳转链接" prop="url">
                <el-input
                  v-model="addData.url"
                  placeholder="请输入跳转链接"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注信息" prop="object">
                <el-input
                  v-model="addData.object"
                  placeholder="请输入备注信息"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>                                     
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
export default {
  components: {
    upload,
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        url: "",
        icon: "",
        name: "",
        status: "",
        object: "",
        weight:0,
        object:''
      },
      addDataRules: {
        icon: [{ required: true, message: "请上传图片", trigger: "blur" }],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    siteType(row){
      if(row.site == 0){
        return '首页顶部'
      }else if(row.site == 1){
        return '广告位'
      }else if(row.site == 2){
        return '二手闲置'
      }
    },
    // 修改用户状态
    updataStatus(row) {
      let data = {
        id:row.id,
        status:row.status ? 1 : -1
      }
      this.$Apis.homeCategoryUpdateStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },    
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.homeCategoryDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            icon: this.addData.icon,
            object: this.addData.object,
            url:this.addData.url,
            name: this.addData.name,
            status: 1,
            weight:this.addData.weight,
            object:this.addData.object  
          };
          this.$Apis.homeCategoryAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
      };
      this.$Apis.homeCategoryList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item,ind) => {
            item.status = item.status == 1 ? true : false;
            item.ind = ind + 1
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>